export default __webpack_public_path__ + "static/media/helm_of_the_forsaken.a884969f.jpg";